import type {
  ReviewListItem,
  ReviewListKpis,
  ReviewListSentiment,
  ReviewListSource,
  ReviewListSourceKey,
  ReviewListLanguage,
  ReviewListManagementResponse,
  ManagementResponseDraft,
  KpiReport,
  SelectedTonesManResModalData,
  GuestManResModalData,
  PropertyManResModalData,
  FromManResModalData,
  ToManResModalData,
  ToneListManResModalData,
  SubjectManResModalData,
  TemplateTextManResModalData,
  MessageTextManResModalData1,
  AiTemplateIdManResModalData,
  AiTemplateTextManResModalData,
  MessageTextManResModalData2,
} from '@common/types';

const KPI_RATINGS: ReadonlyArray<number> = [20, 40, 60, 80, 100];

const PROPERTY_NAME = 'The Langdon';
const PROPERTY_ID = 1001;
const USER_ID = 1;
const USER_NAME = 'John Doe';

const SOURCES: Record<ReviewListSourceKey, ReviewListSource> = {
  guestrevu: {
    id: 1,
    key: 'guestrevu',
    description: 'GuestRevu',
    initial: 'G',
    logoUrl: '/assets/images/logos/icon.svg',
  },
  trip_advisor: {
    id: 3,
    key: 'trip_advisor',
    description: 'TripAdvisor',
    initial: 'T',
    logoUrl: '/assets/images/logos/tripadvisor.svg',
  },
  booking_com: {
    id: 4,
    key: 'booking_com',
    description: 'Booking.com',
    initial: 'B',
    logoUrl: '/assets/images/logos/booking.svg',
  },
  google: {
    id: 5,
    key: 'google',
    description: 'Google',
    initial: 'G',
    logoUrl: '/assets/images/logos/google.svg',
  },
  expedia: {
    id: 6,
    key: 'expedia',
    description: 'Expedia',
    initial: 'E',
    logoUrl: '/assets/images/logos/expedia.svg',
  },
  hotels: { id: 7, key: 'hotels', description: 'Hotels.com', initial: 'H' },
  agoda: { id: 8, key: 'agoda', description: 'Agoda', initial: 'A' },
  hellopeter: { id: 9, key: 'hellopeter', description: 'HelloPeter', initial: 'HP' },
  RCI: { id: 10, key: 'RCI', description: 'RCI', initial: 'R' },
  RCI_comment_cards: { id: 11, key: 'RCI_comment_cards', description: 'RCI Comment Cards', initial: 'RCC' },
};

interface SeedSpec {
  date: string;
  displayName: string;
  email: string | null;
  sourceKey: ReviewListSourceKey;
  reviewRating: number | null;
  sentiment: ReviewListSentiment;
  hotAlerts: number;
  readFlag: boolean;
  publishFlag: boolean;
  resolvedFlag: boolean;
  unsubscribeFlag?: boolean;
  doNotReply?: boolean;
  respondable: boolean;
  managementResponseSent?: boolean;
  managementResponsePending?: boolean;
  externalStatusDescription?: string | null;
  emailOpenedAt?: string | null;
  kpis: ReviewListKpis;
  managementResponse?: ReviewListManagementResponse | null;
}

const SPECS: SeedSpec[] = [
  {
    date: '2026-05-21',
    displayName: 'Sam Draper',
    email: 'sam@guestrevu.com',
    sourceKey: 'guestrevu',
    reviewRating: 80,
    sentiment: 'unknown',
    hotAlerts: 1,
    readFlag: false,
    publishFlag: false,
    resolvedFlag: false,
    respondable: false,
    kpis: {
      nps: 5,
      overallSat: 80,
      service: 80,
      valueForMoney: 80,
      cleanliness: 80,
      room: 80,
      sleepQuality: 80,
      location: 80,
      reservation: 80,
      reception: 80,
      wifi: 80,
    },
    managementResponse: null,
  },
  {
    date: '2026-05-20',
    displayName: 'Amelia O Bremen',
    email: null,
    sourceKey: 'guestrevu',
    reviewRating: 20,
    sentiment: 'unknown',
    hotAlerts: 1,
    readFlag: false,
    publishFlag: false,
    resolvedFlag: false,
    respondable: false,
    kpis: {
      nps: 0,
      overallSat: 20,
      service: 20,
      valueForMoney: 20,
      cleanliness: 20,
      room: 20,
      sleepQuality: 20,
      location: 20,
      reservation: 20,
      reception: 20,
      wifi: 20,
    },
    managementResponse: null,
  },
  {
    date: '2026-05-18',
    displayName: 'Ryan Coutts',
    email: 'ryacou@gmail.com',
    sourceKey: 'guestrevu',
    reviewRating: 37,
    sentiment: 'negative',
    hotAlerts: 1,
    readFlag: true,
    publishFlag: false,
    resolvedFlag: false,
    respondable: false,
    kpis: {
      nps: 5,
      overallSat: 20,
      service: 40,
      valueForMoney: 60,
      cleanliness: 80,
      room: 100,
      location: 100,
      reservation: 80,
      reception: 60,
      wifi: 40,
    },
    managementResponse: null,
  },
  {
    date: '2026-05-07',
    displayName: 'Anonymous',
    email: null,
    sourceKey: 'guestrevu',
    reviewRating: null,
    sentiment: 'unknown',
    hotAlerts: 0,
    readFlag: false,
    publishFlag: false,
    resolvedFlag: false,
    respondable: false,
    kpis: {},
    managementResponse: null,
  },
  {
    date: '2026-05-05',
    displayName: 'T R',
    email: 'gig@bababeachclub.com',
    sourceKey: 'guestrevu',
    reviewRating: 96,
    sentiment: 'positive',
    hotAlerts: 0,
    readFlag: true,
    publishFlag: true,
    resolvedFlag: false,
    respondable: true,
    kpis: {
      nps: 10,
      overallSat: 100,
      service: 80,
      valueForMoney: 100,
      cleanliness: 100,
      room: 100,
      sleepQuality: 100,
      location: 80,
      reservation: 60,
      reception: 100,
      wifi: 80,
    },
    managementResponse: null,
  },
  {
    date: '2026-04-27',
    displayName: 'SOFIA HP',
    email: 'hpirun80@gmail.com',
    sourceKey: 'guestrevu',
    reviewRating: 43,
    sentiment: 'negative',
    hotAlerts: 1,
    readFlag: false,
    publishFlag: false,
    resolvedFlag: false,
    doNotReply: true,
    respondable: false,
    kpis: {
      nps: 3,
      overallSat: 40,
      service: 40,
      valueForMoney: 40,
      cleanliness: 20,
      room: 60,
      sleepQuality: 40,
      location: 60,
    },
    managementResponse: null,
  },
  {
    date: '2026-04-22',
    displayName: 'Maureen M',
    email: 'maureenM@gmail.com',
    sourceKey: 'trip_advisor',
    reviewRating: 100,
    sentiment: 'positive',
    hotAlerts: 0,
    readFlag: true,
    publishFlag: false,
    resolvedFlag: false,
    respondable: true,
    managementResponsePending: true,
    externalStatusDescription: 'Published',
    kpis: {
      overallSat: 100,
      service: 100,
      valueForMoney: 100,
      cleanliness: 100,
      room: 100,
      sleepQuality: 100,
      location: 100,
    },
    managementResponse: {
      content: "Dear Maureen M,\n\n" + 'Thank you for your feedback. We hope to welcome you back soon!' + "\n\nSincerely,\n" + PROPERTY_NAME,
      emailProviderId: 1,
      responseDate: '2026-04-26',
      subject: 'Thank you for your review!',
      userId: 15321564489,
      username: 'Maureen M',
      managementResponse: 0,
    },
  },
  {
    date: '2026-04-21',
    displayName: 'Gail',
    email: null,
    sourceKey: 'booking_com',
    reviewRating: 70,
    sentiment: 'positive',
    hotAlerts: 0,
    readFlag: true,
    publishFlag: false,
    resolvedFlag: false,
    respondable: true,
    externalStatusDescription: 'Published',
    kpis: { overallSat: 70 },
    managementResponse: null,
  },
  {
    date: '2026-04-21',
    displayName: 'Nuša Stojko',
    email: 'nusa.stojko@gmail.com',
    sourceKey: 'guestrevu',
    reviewRating: 96,
    sentiment: 'positive',
    hotAlerts: 0,
    readFlag: true,
    publishFlag: true,
    resolvedFlag: false,
    respondable: true,
    emailOpenedAt: '2026-04-22 10:14:02',
    kpis: {
      nps: 9,
      overallSat: 100,
      service: 100,
      valueForMoney: 100,
      cleanliness: 60,
      room: 100,
      sleepQuality: 80,
      location: 80,
    },
    managementResponse: null,
  },
  {
    date: '2026-04-20',
    displayName: 'Anonymous',
    email: null,
    sourceKey: 'guestrevu',
    reviewRating: null,
    sentiment: 'unknown',
    hotAlerts: 0,
    readFlag: false,
    publishFlag: false,
    resolvedFlag: false,
    respondable: false,
    kpis: {},
    managementResponse: null,
  },
];

const PADDING_NAMES: ReadonlyArray<string> = [
  'Jonas Iversen',
  'Lien Tran',
  'Hannah Klein',
  'Pablo Castellanos',
  'Yuki Nakamura',
  'Olivia Whitley',
  'Marc Dubois',
  'Aoife Brennan',
  'Ravi Patel',
  'Greta Sundqvist',
  'Tomás Ferreira',
  'Adira Cohen',
  'Erin O’Sullivan',
  'Kofi Mensah',
  'Ines Kowalska',
  'Henrik Lindgren',
  'Diego Rojas',
  'Mei Ling',
  'Sofiya Petrov',
  'Bashir Khan',
  'Camille Laurent',
  'Liam Walsh',
  'Anaya Sharma',
  'Marek Novak',
  'Niamh Doherty',
  'Theo Rasmussen',
  'Beatriz Soares',
  'Ondrej Havel',
  'Inara Rahimi',
  'Carla Pizzi',
  'Felix Westergaard',
  'Mira Halonen',
  'Aaron McGrath',
  'Saira Younis',
  'Daniela Aguirre',
  'Henry Chamberlain',
  'Naoko Yamada',
  'Ruslan Volkov',
  'Selma Karlsson',
  'Owen Caldwell',
];

const PADDING_SOURCES: ReadonlyArray<ReviewListSourceKey> = [
  'guestrevu',
  'guestrevu',
  'guestrevu',
  'trip_advisor',
  'booking_com',
  'google',
  'expedia',
  'hotels',
  'agoda',
];

const PADDING_SENTIMENT: ReadonlyArray<ReviewListSentiment> = [
  'positive',
  'positive',
  'positive',
  'neutral',
  'negative',
  'unknown',
];

export const LANGUAGE_OPTIONS: ReadonlyArray<ReviewListLanguage> = [
  { id: 1, name: 'English', shortCode: 'en' },
  { id: 2, name: 'Afrikaans', shortCode: 'af' },
  { id: 3, name: 'French', shortCode: 'fr' },
  { id: 4, name: 'German', shortCode: 'de' },
  { id: 5, name: 'Spanish', shortCode: 'es' },
  { id: 6, name: 'Portuguese', shortCode: 'pt' },
  { id: 7, name: 'Mandarin', shortCode: 'zh' },
  { id: 8, name: 'Unknown', shortCode: '' },
];

const PADDING_MANRES: ReadonlyArray<ManagementResponseDraft> = [
  { content: 'Thank you for your feedback. We hope to welcome you back soon!', subject: 'Thank you for your review!' },
  { content: 'We are sorry to hear about your experience. Please contact us at support@example.com for further assistance.', subject: 'Regarding Your Review' },
  { content: 'We appreciate your comments and will use them to improve our services.', subject: 'Thank You for Your Feedback' },
  { content: 'Your feedback is important to us. We are looking into the issues you mentioned.', subject: 'We Are Looking Into Your Feedback' },
  { content: 'Thank you for taking the time to share your experience. We hope to see you again!', subject: 'Thank You for Your Review' },
];

function dateOffset(daysFromAnchor: number): string {
  const anchor = Date.UTC(2026, 3, 19);
  const ms = anchor - daysFromAnchor * 24 * 60 * 60 * 1000;
  const d = new Date(ms);
  const y = d.getUTCFullYear();
  const m = String(d.getUTCMonth() + 1).padStart(2, '0');
  const day = String(d.getUTCDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

function pickKpis(rating: number | null): ReviewListKpis {
  if (rating == null) return {};
  const base = KPI_RATINGS.find((v) => Math.abs(v - rating) <= 20) ?? 60;
  const sway = (delta: number): number => {
    const candidate = base + delta;
    if (candidate < 0) return 0;
    if (candidate > 100) return 100;
    return candidate;
  };
  return {
    nps: Math.max(0, Math.min(10, Math.round(rating / 10))),
    overallSat: base,
    service: sway(0),
    valueForMoney: sway(-20),
    cleanliness: sway(20),
    room: sway(0),
    sleepQuality: sway(-20),
    location: sway(20),
    reservation: sway(0),
    reception: sway(20),
    wifi: sway(-20),
  };
}

function manRes(daysFromAnchor: number, name: string, respondable: boolean, email: string | null) {
  const anchor = Date.UTC(2026, 3, 19);
  const ms = anchor - daysFromAnchor * 24 * 60 * 60 * 1000;
  const d = new Date(ms);
  const manResMessage = PADDING_MANRES[Math.floor(Math.random() * PADDING_MANRES.length)];
  const mangResNumber = Math.floor(Math.random() * 2);
  const userID = Math.floor(Math.random() * 1000);
  return {
    content: "Dear " + name + ",\n\n" + manResMessage.content + "\n\nSincerely,\n" + PROPERTY_NAME,
    emailProviderId: null,
    responseDate: d.toISOString(),
    subject: manResMessage.subject,
    userId: USER_ID,
    username: USER_NAME,
    managementResponse: mangResNumber === 0 ? 0 : 2,
  }
}

function buildPaddedSpec(index: number): SeedSpec {
  const name = PADDING_NAMES[index % PADDING_NAMES.length];
  const sourceKey = PADDING_SOURCES[index % PADDING_SOURCES.length];
  const sentiment = PADDING_SENTIMENT[index % PADDING_SENTIMENT.length];
  const rating = KPI_RATINGS[(index + 2) % KPI_RATINGS.length];
  const hotAlerts = sentiment === 'negative' || rating < 40 ? 1 : 0;
  const respondable = sourceKey !== 'guestrevu';
  const email = index % 4 === 0 ? null : `${name.split(' ')[0]?.toLowerCase()}.${index}@example.com`.replace(/[^a-z0-9.@]/g, '');
  const manResPending = respondable && index % 7 === 0;
  return {
    date: dateOffset(index + 4),
    displayName: name,
    email: email,
    sourceKey,
    reviewRating: rating,
    sentiment,
    hotAlerts,
    readFlag: index % 3 !== 0,
    publishFlag: respondable && index % 5 === 0,
    resolvedFlag: false,
    respondable,
    managementResponseSent: respondable && index % 6 === 0,
    managementResponsePending: manResPending,
    externalStatusDescription: respondable ? 'Published' : null,
    emailOpenedAt: index % 6 === 0 ? dateOffset(index + 1) : null,
    kpis: pickKpis(rating),
    managementResponse: manResPending === true ? manRes(index, name, respondable, email) : null,
  };
}

function specToItem(spec: SeedSpec, index: number): ReviewListItem {
  const source = SOURCES[spec.sourceKey];
  return {
    id: 116_000_000 - index * 137,
    date: spec.date,
    displayName: spec.displayName,
    email: spec.email,
    propertyId: PROPERTY_ID,
    propertyName: PROPERTY_NAME,
    source,
    reviewRating: spec.reviewRating,
    sentiment: spec.sentiment,
    hotAlerts: spec.hotAlerts,
    readFlag: spec.readFlag,
    publishFlag: spec.publishFlag,
    resolvedFlag: spec.resolvedFlag,
    unsubscribeFlag: spec.unsubscribeFlag ?? false,
    doNotReply: spec.doNotReply ?? false,
    respondable: spec.respondable,
    managementResponseSent: spec.managementResponseSent ?? false,
    managementResponsePending: spec.managementResponsePending ?? false,
    externalStatusDescription: spec.externalStatusDescription ?? null,
    emailOpenedAt: spec.emailOpenedAt ?? null,
    kpis: spec.kpis,
    managementResponse: spec.managementResponse ?? null,
  };
}

function buildSeed(): ReviewListItem[] {
  const items = SPECS.map((spec, index) => specToItem(spec, index));
  for (let i = 0; items.length < 50; i++) {
    items.push(specToItem(buildPaddedSpec(i), items.length));
  }
  return items;
}

export const REVIEWS_LISTING_SEED: ReadonlyArray<ReviewListItem> = buildSeed();

export const PROPERTY_SEED: PropertyManResModalData = {
  "Id": 1001,
  "CreationDate": "2018-01-23T10:06:39+00:00",
  "StatusId": 1,
  "ClassificationTypeId": 1,
  "PropertyTypeId": 1,
  "Name": "The Langdon",
  "UpdateDate": "2026-04-20T09:40:00+00:00",
  "SenderEmail": "thelangdon@guestrevuapp.com",
  "SenderName": "The Langdon",
  "ForwardEmail": "shannon@guestrevu.com",
  "DisableAutoresponsesFlag": 0,
  "DisableForwardingFlag": 0,
  "PausedEndDate": null,
  "OleryCompanyId": null,
  "TripadvisorId": "182633",
  "CentricityCompanyId": null,
  "ChicId": null,
  "NoReviewPeriod": 0,
  "NoDedupe": 0,
  "TempFlag": 1,
  "HubspotId": 148117427,
  "GoogleAccessToken": null,
  "GoogleLocationId": null,
  "TwitterOauthToken": "2373442004-ItjRxI3rXAnVC52ixTojV2UX905GCnNRXXE8oq2",
  "TwitterOauthTokenSecret": "r6AMGl30jBhpypZaBLBqny4cVNF90ab1Bh8ehfxZl34kM",
  "FacebookPageAccessToken": null,
  "FacebookPageId": null,
  "FacebookPageSubscribedFlag": 0,
  "DisableAllNotificationsFlag": 0,
  "BookingAccessToken": null,
  "BookingCode": null,
  "TripadvisorApiFlag": 1,
  "SsuFlag": 0,
  "ReviewAutoResolveFlag": 0,
  "AwsEmailServiceFlag": 0,
  "ExternalSendFlag": 0
}

export const GUEST_SEED: GuestManResModalData = {
  "Id": 82021,
  "CreationDate": "2018-01-23T10:06:40+00:00",
  "UpdateDate": "2026-05-21T08:53:09+00:00",
  "StatusId": 1,
  "PropertyId": 1001,
  "SourceTypeId": 1,
  "LanguageId": 39,
  "LatestActionTypeId": 12,
  "Email": "sam@guestrevu.com",
  "DisplayName": "Sam Draper",
  "UnsubscribeFlag": 0,
  "UnsubscribeDate": null,
  "ExternalGuestId": "",
  "GuestProfiles": [
    {
      "Id": 82021,
      "CreationDate": "2018-01-23T10:06:40+00:00",
      "StatusId": 1,
      "GuestId": 82021,
      "SourceGuestId": null,
      "SourceTypeId": 1,
      "NationalityCountryId": null,
      "AddressCountryId": 250,
      "LanguageId": 39,
      "GuestLikelyhood": 100,
      "Email": "sam@guestrevu.com",
      "MemberNumber": "123456",
      "MobileNumber": "0724769246",
      "Title": "Mr",
      "Salutation": "Dear",
      "DisplayName": "Sam Draper",
      "FirstName": "Sam",
      "LastName": "Draper",
      "Gender": "m",
      "Age": 46,
      "DateOfBirth": "1971-12-05",
      "AgeRange": null,
      "HouseNumber": "18",
      "Address1": "Delphinium Drive",
      "Address2": "Linton Grange",
      "Suburb": "Westering",
      "PostalCode": "6015",
      "ProvinceState": "Eastern Cape",
      "City": "Port Elizabeth",
      "VipCode": null,
      "VipFlag": 0,
      "SmokerFlag": 0,
      "BlackListedFlag": 0,
      "GoogleImageUrl": null,
      "LoyalityLevel": null,
      "IdPassportNumber": null,
      "Note": null,
      "GuestEducations": [],
      "GuestOrganisations": [],
      "GuestSocialProfiles": []
    }
  ]
}

export const REVIEW_REPORT_SEED: KpiReport[] = [
  {
    key: "Q_NET_PROMOTER",
    values: {
      "header": "On a scale of 0 to 10, what is the likelihood that you would recommend us to friends and family?",
      "keepformat": "No",
      "count": 1,
      "answer": "5",
      "survey_id": 4926,
      "review_id": 116445462,
      "answer_id": 1357944,
      "alerts": [
        {
          "Name": "Alert Logic: General Alerts",
          "Description": "Alert Logic: General Alerts",
          "Colour": null,
          "Id": 47162,
        }
      ]
    }
  },
  {
    key: "Q_KPI_MAIN",
    values: {
      "header": "Please rate your overall satisfaction with the following aspects of your recent stay with us.",
      "keepformat": "Yes",
      "count": 10,
      "questions": [
        {
          "survey_answer_type_id": 1,
          "question": "Overall rating for this property",
          "answer": "4",
          "survey_id": 4926,
          "review_id": 116445462,
          "answer_id": 1357954,
        },
        {
          "survey_answer_type_id": 1,
          "question": "Service you received",
          "answer": "4",
          "survey_id": 4926,
          "review_id": 116445462,
          "answer_id": 1357960,
        },
        {
          "survey_answer_type_id": 1,
          "question": "Value for money",
          "answer": "4",
          "survey_id": 4926,
          "review_id": 116445462,
          "answer_id": 1357966,
        },
        {
          "survey_answer_type_id": 1,
          "question": "Cleanliness",
          "answer": "4",
          "survey_id": 4926,
          "review_id": 116445462,
          "answer_id": 1357972,
        },
        {
          "survey_answer_type_id": 1,
          "question": "Room quality",
          "answer": "4",
          "survey_id": 4926,
          "review_id": 116445462,
          "answer_id": 1357978,
        },
        {
          "survey_answer_type_id": 1,
          "question": "Sleep quality",
          "answer": "4",
          "survey_id": 4926,
          "review_id": 116445462,
          "answer_id": 1357984,
        },
        {
          "survey_answer_type_id": 1,
          "question": "General location of property",
          "answer": "4",
          "survey_id": 4926,
          "review_id": 116445462,
          "answer_id": 1357990,
        },
        {
          "survey_answer_type_id": 1,
          "question": "Reservations",
          "answer": "4",
          "survey_id": 4926,
          "review_id": 116445462,
          "answer_id": 1357996,
        },
        {
          "survey_answer_type_id": 1,
          "question": "Reception team",
          "answer": "4",
          "survey_id": 4926,
          "review_id": 116445462,
          "answer_id": 1358002,
        },
        {
          "survey_answer_type_id": 1,
          "question": "Wi-Fi quality",
          "answer": "4",
          "survey_id": 4926,
          "review_id": 116445462,
          "answer_id": 1358008,
        }
      ]
    }
  },
  {
    key: "Q_ALREADY_VISITED",
    values: {
      "header": "Have you visited us before?",
      "keepformat": "No",
      "count": 1,
      "answer": "Yes",
      "survey_id": 4926,
      "review_id": 116445462,
      "answer_id": 1358013
    }
  },
  {
    key: "Q_HOW_HEAR_OF_US",
    values: {
      "header": "How did you hear about us?",
      "keepformat": "No",
      "count": 1,
      "answer": "Word of mouth",
      "survey_id": 4926,
      "review_id": 116445462,
      "answer_id": 1358026
    }
  }
]

export const SELECTED_TONES_SEED: SelectedTonesManResModalData = {
  "Professional": false,
  "Concise": false,
  "Friendly": true,
  "Verbose": false,
  "Warm": false,
  "Caring": true,
  "Formal": false,
  "Conversational": false,
  "Casual": false,
  "Quirky": false
}

export const TONE_LIST_SEED: ToneListManResModalData = [
  'Professional',
  'Concise',
  'Friendly',
  'Verbose',
  'Warm',
  'Caring',
  'Formal',
  'Conversational',
  'Casual',
  'Quirky'
];

export const FROM_SEED: FromManResModalData = 'thelangdon@guestrevuapp.com'
export const TO_SEED: ToManResModalData = 'sam@guestrevu.com'
export const SUBJECT_SEED: SubjectManResModalData = "The Langdon Post Stay Survey Management Response";
export const TEMPLATE_TEXT_SEED: TemplateTextManResModalData = '<p>Dear Sam Draper,</p>'
  + '<p>Thank you for taking the time to complete the survey about your stay at The Langdon. We always appreciate hearing feedback about the experience that we provide, and your comments have been taken to heart.</p>'
  + '<p><strong>[Address comments here]</strong></p>'
  + '<p>We hope to see you at The Langdon again soon!</p>'
  + '<p>Kind regards,</p>'
  + '<p>The Langdon</p>';
export const MESSAGE_TEXT_1_SEED: MessageTextManResModalData1 = '<p>Dear Sam Draper,</p>'
  + '<p>Thank you for taking the time to complete the survey about your stay at The Langdon. We always appreciate hearing feedback about the experience that we provide, and your comments have been taken to heart.</p>'
  + '<p><strong>[Address comments here]</strong></p>'
  + '<p>We hope to see you at The Langdon again soon!</p>'
  + '<p>Kind regards,</p>'
  + '<p>The Langdon</p>';
export const AI_TEMPLATE_ID_SEED: AiTemplateIdManResModalData = 437014
export const AI_TEMPLATE_TEXT_SEED: AiTemplateTextManResModalData = '<p>Dear Sam Draper,<br>We\'re delighted to hear you had a pleasant stay with us. Thank you for sharing your feedback on various aspects of your experience. As a token of our appreciation, we would like to offer you a 10% discount on your next booking with us. Simply use coupon code 3434535 during your reservation. At The Langdon, we take pride in our seasonal, locally sourced menu, ensuring a fresh dining experience for our guests. If you have any specific dietary preferences for your next visit, please let us know in advance.<br>We look forward to welcoming you back to The Langdon soon!<br>Kind regards,<br>John<br>Manager</p>'
export const MESSAGE_TEXT_2_SEED: MessageTextManResModalData2 = '<p>Dear Sam Draper,<br>We\'re delighted to hear you had a pleasant stay with us. Thank you for sharing your feedback on various aspects of your experience. As a token of our appreciation, we would like to offer you a 10% discount on your next booking with us. Simply use coupon code 3434535 during your reservation. At The Langdon, we take pride in our seasonal, locally sourced menu, ensuring a fresh dining experience for our guests. If you have any specific dietary preferences for your next visit, please let us know in advance.<br>We look forward to welcoming you back to The Langdon soon!<br>Kind regards,<br>John<br>Manager</p>'
export const ORM_TEMPLATE_TEXT_SEED = "<p>Dear Gail,<br><br>[Address specific comments from the review]<br><br>We look forward to welcoming you back to The Langdon soon!<br><br>Kind regards,<br>John<br>Manager</p>"
export const ORM_REPORT_SEED: KpiReport[] = [
  {
    key: "Q_REVIEW_TITLE",
    values: {
      "header": "Review Title",
      "keepformat": "No",
      "count": 1,
      "answer": "Clean accommodation.",
      "translation": "",
      "language_id": null,
      "text": true,
      "survey_id": 1,
      "review_id": 114910806,
      "answer_id": 1
    }
  },
  {
    key: "Q_KPI_MAIN",
    values: {
      "header": "Service Ratings",
      "keepformat": "Yes",
      "count": 1,
      "questions": [
        {
          "survey_answer_type_id": 4,
          "question": "Overall",
          "answer": "70%",
          "survey_id": 1,
          "review_id": 114910806,
          "answer_id": 2,
        }
      ]
    }
  },
  {
    key: "Q_GOOD_COMMENT",
    values: {
      "header": "Good",
      "keepformat": "No",
      "count": 1,
      "answer": "Clean <br />\nParking available",
      "translation": "",
      "language_id": null,
      "text": true,
      "survey_id": 1,
      "review_id": 114910806,
      "answer_id": 18
    }
  },
  {
    key: "Q_BAD_COMMENT",
    values: {
      "header": "Bad",
      "keepformat": "No",
      "count": 1,
      "answer": "Nothing",
      "translation": "",
      "language_id": null,
      "text": true,
      "survey_id": 1,
      "review_id": 114910806,
      "answer_id": 19
    }
  },
  {
    key: "Q_TRAVEL_TYPE",
    values: {
      "header": "Travel Type",
      "keepformat": "No",
      "count": 1,
      "answer": "Leisure trip",
      "survey_id": 1,
      "review_id": 114910806,
      "answer_id": 26
    }
  },
]